<template>
  <div>
    <div class="board-container">
      <div class="container pt-3">
        <div class="row g-4">
          <div class="d-flex align-items-center">
            <UserInformationCard class="flex-grow-1 me-3"/>
            <UpdatePassword/>
          </div>
          <div v-for="module in getAllowedModules"
               :key="module.route"
               class="col-12 col-md-6 col-lg-4"
          >
            <ModuleCard :moduleData="module"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleCard from "./BoardContent/Module-card.vue";
import {mapGetters} from "vuex";
import UserInformationCard from "@/components/home/User-information-card.vue";
import UpdatePassword from "@/components/home/Update-Password.vue";

export default {
  name: 'BoardContent',

  components: {
    ModuleCard,
    UserInformationCard,
    UpdatePassword,
  },

  data() {
    return {
      modules: [
        {
          title: 'Mantenedor de usuarios',
          description: 'Administrar cuentas de usuario, roles y permisos',
          icon: 'person-circle',
          colorClass: 'bg-primary-soft',
          route: '/UserMaintainer',
          permission: 'usuarios-vista'
        },
        {
          title: 'Repositorio de documentos',
          description: 'Crear, enviar y gestionar documentos',
          icon: 'file-text',
          colorClass: 'bg-success-soft',
          route: '/DocumentRepository',
          permission: 'documentos-vista'
        },
        {
          title: 'Reuniones',
          description: 'Programar y visualizar reuniones',
          icon: 'calendar',
          colorClass: 'bg-warning-soft',
          route: '/Meeting',
          permission: 'reuniones-vista'
        },
        {
          title: 'Declaraciones',
          description: 'Crear y gestionar declaraciones',
          icon: 'file-pdf',
          colorClass: 'bg-danger-soft',
          route: '/Statements',
          permission: 'declaraciones-vista'
        },
        {
          title: 'Empresas administradas',
          description: 'Crear, asignar y eliminar socios',
          icon: 'card-checklist',
          colorClass: 'bg-primary-soft',
          route: '/ManagedCompanies',
          permission: 'empresas-vista'
        },
        {
          title: 'Canal de denuncia',
          description: 'Realizar denuncias Compliance / Ley Karin',
          icon: 'mailbox',
          colorClass: 'bg-info-soft',
          route: '/Denounce'
        },
        {
          title: 'Capacitaciones',
          description: 'Realizar capacitaciones',
          icon: 'book-half',
          colorClass: 'bg-danger-soft',
          route: '/Training',
          permission: 'capacitaciones-vista'
        },
      ]
    }
  },

  computed: {
    ...mapGetters(['getPermissions']),
    getAllowedModules() {
      return this.modules.filter(module => {
        let permission = module.permission
        if (!permission) {
          return true
        } else {
          return this.getPermissions.includes(module.permission)
        }
      })
    }
  },
}
</script>

<style scoped>
.board-container {
  background-color: #f8f9fa;
  overflow-y: scroll;
  height: 85vh;
}
</style>